<template>
  <div style="height: 100%;width: 100%">
    <el-row style="height: 100%">
      <el-col :span="5" style="height: 100%">
        <div class="left-content">
          <div style="height: 50px">
            <div style="color: #1a1a1a"><strong>书籍列表</strong></div>
          </div>
          <div style="height: calc(100% - 100px)">
            <el-tree highlight-current node-key="showId" :data="treeData" :props="defaultProps"
                     default-expand-all
                     @node-click="handleTreeClick"
                     :expand-on-click-node="false"
                     ref="treeData">
              <div style="width: 100%" slot-scope="{ node, data }">
                <img style="width: 20px;" src="../../assets/img/bookIcon.png">
                <span>{{ node.label }}</span>
              </div>
            </el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="19" style="height: 100%">
        <div class="right-content">
          <see-auth-code ref="seeAuthCode" v-if="seeAuthCodeShow" v-model="seeAuthCodeShow"></see-auth-code>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {getBookList} from '../../api/book'
import SeeAuthCode from '../../components/materialManagement/seeAuthCode'

export default {
  name: 'authCodeManagement',
  components: {SeeAuthCode},
  data () {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },

      seeAuthCodeShow: false,
      seeAuthCodeObj: {}
    }
  },
  created () {
    this.getBookListData()
  },
  methods: {
    getBookListData () {
      let body = {
        pageIndex: 1,
        pageSize: 9999
      }
      getBookList(body).then(res => {
        this.treeData = res.data.array
        if (this.treeData.length !== 0) {
          this.viewAuthCode(this.treeData[0])
        }
      })
    },
    getFatherBook () {
      this.getBookListData()
    },
    handleTreeClick (node) {
      this.viewAuthCode(node)
    },
    viewAuthCode (item) {
      let vm = this
      this.seeAuthCodeObj.row = item
      this.seeAuthCodeShow = true
      setTimeout(function () {
        vm.$refs.seeAuthCode.getInitData(vm.seeAuthCodeObj)
      }, 50)
    }
  }
}
</script>

<style scoped>
  .add-button{
    width: 100%;
    height: 40px;
    margin-top: 20px;
    color: #fff;
    background-color: #3e93ff;
    border-radius: 5px;
  }
  .left-content{
    padding: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    background-color: #fff;
    box-shadow: 0 0 16px 0 rgba(169, 169, 169, 0.2);
    border-radius: 8px;
  }
  .right-content{
    margin-left: 10px;
    padding: 20px;
    width: calc(100% - 50px);
    height: calc(100% - 40px);
    background-color: #fff;
    box-shadow: 0 0 16px 0 rgba(169, 169, 169, 0.2);
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/secretKeyManagement/authCodeManagement.vue